// extracted by mini-css-extract-plugin
export var searchContainer = "NavSearch-module--searchContainer--c791e";